import React, { memo } from 'react';
import { WidgetHeaderTextType } from '../types';
import { ArrowIcon } from '../utilities/arrowIcon';
import { WidgetHeader } from '../widgetHeader.jsx';

interface CommonWidgetHeaderProps {
    headerText: WidgetHeaderTextType;
}

export const CommonWidgetHeader = memo(({ headerText }: CommonWidgetHeaderProps) => {
    return (
        <WidgetHeader headerText={headerText} iconStyle={{ transform: 'rotate(-90deg)' }}>
            <ArrowIcon />
        </WidgetHeader>
    );
});

CommonWidgetHeader.displayName = 'CommonWidgetHeader';
